import deadlineReducer from './deadline';
export * from './deadline';

export default { deadline: deadlineReducer };
